import React from 'react';

import PropTypes from 'prop-types';

import { Logger } from 'aws-amplify';

import {
  Avatar,
  Card,
  CardHeader,
  CardContent,
  Grid,
  IconButton,
} from '@material-ui/core';

import { 
  makeStyles 
} from '@material-ui/core/styles';

import {
  Input as InputIcon,
  MoreVert as MoreVertIcon,
} from '@material-ui/icons';

import {
  DetailPanel,
} from "../../../packages/detail-panel";

import { 
  ResourceRef,
} from '../../resource';

import { 
  useWorkloadDataConfiguration,
} from '../../workload';

import {
  useExecution,
} from '../hooks';

import {
  ExecutionChip,
  ExecutionInputLog,
  ExecutionInputLogCloudWatch,
  ExecutionInputTimeline,
} from '.';

const logger = new Logger('ExecutionInputCard');

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  sections: {
    padding: theme.spacing(0),
    display: 'flex',
    flexDirection: 'row',
  },
  section: {
    minWidth: 0,
    flexGrow: 1,
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

export default function ExecutionInputCard(props) {
  const { executionInput } = props;

  const [expandExecutionInputLog, doExpandExecutionInputLog] = React.useState(0);
  const [initialLogOptions, setInitialLogOptions] = React.useState({});

  const { resource: workload } = useWorkloadDataConfiguration(executionInput?executionInput.WorkloadId:null);
  const { execution } = useExecution(executionInput?executionInput.ExecutionId:null);

  const classes = useStyles();
  // const inputName=executionInput?executionInput.InputUri.split('/').slice(-1)[0]:null;

  const handleTimelineAttemptClicked = (attempt) => {
    setInitialLogOptions({ initialGroup: attempt });
    doExpandExecutionInputLog(e => e+1);
  };

  const handleTimelineShowLog = (attempt, logEntry) => {
    setInitialLogOptions({ 
      initialGroup: attempt,
      initialMatch: logEntry,
    });
    doExpandExecutionInputLog(e => e+1);
  };
  
  if(!workload) return(null); 
  if(!execution) return(null); 
  if(!executionInput) return(null); 

  logger.debug(workload,execution,executionInput);

  // enrich the executionInput record  
  executionInput['Workload'] = workload;
  executionInput['Execution'] = execution;
  executionInput['SourceDataset'] = workload.DataConfiguration.SourceDatasets.find(dataset => 
    dataset.ResourceId === executionInput.SourceDatasetId);

  const fields=[
    { section: "Timeline", expandable: true, expanded: true, fields: [
      { name: "ExecutionTimeline", label: "_", 
        component: ExecutionInputTimeline, options: { 
          executionInput: executionInput, 
          onAttemptClicked: handleTimelineAttemptClicked,
          onShowLog: handleTimelineShowLog,
        } }, 
    ], fieldWidth: null},
    { section: "Related", expandable: true, expanded: true, fields: [ 
      { name: "ClientAccountId", label: "Client", component: ResourceRef, 
        options: { type: 'Client', format: 'qualified', adorned: true } },
      { name: "Workload", label: "Workload", component: ResourceRef, 
        options: { type: 'Workload', format: 'qualified', adorned: true } },
      { name: "Execution", label: "Execution", component: ExecutionChip }, 
    ]},
  ];

  if(executionInput.Result!=='REJECTED') {
    fields.push(
      { section: "Execution Log", 
        expandable: true, expanded: executionInput.Result==='FAILED', expand: expandExecutionInputLog, panelFullWidth: true,
        footer: { 
          component: executionInput.LogStream===null?ExecutionInputLog:ExecutionInputLogCloudWatch,
          props: { 
            executionId: executionInput.ExecutionId, 
            inputUri: executionInput.InputUri,
            ...initialLogOptions
          },
        }
      }
    );
  }

  const sections=[];
  fields.forEach(field => {
    if(field.section) {
      sections.push(field);
    }
  });
  
  return (
    <Card className={classes.root} variant="outlined">
      <CardHeader
        avatar={
          <Avatar aria-label="source-data" className={classes.avatar}>
            <InputIcon/>
          </Avatar>
        }
        action={
          <IconButton aria-label="workload-menu">
            <MoreVertIcon />
          </IconButton>
        }
        title={"Execution Input"} 
        subheader={executionInput.ResultSummary}
      />
      <CardContent>
        <Grid container className={classes.sections}>
          {
            sections.map((section, index) => {
              return(
                <Grid key={"s"+index} item className={classes.section}>
                  <DetailPanel 
                    name={section.section} 
                    data={executionInput}
                    {...section}
                  />
                </Grid>
              );
            })
          }
        </Grid>
      </CardContent>
    </Card>
  );
}

ExecutionInputCard.propTypes = {
  executionInput: PropTypes.object.isRequired,
};


